"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenuState = void 0;
var react_1 = require("react");
// Hook for handling menu like state
function useMenuState() {
    var _a = react_1.useState(null), activeItem = _a[0], setItem = _a[1];
    var isActive = function (name) { return activeItem === name; };
    var createToggleHandler = function (item) { return function () {
        return item === activeItem ? setItem(null) : setItem(item);
    }; };
    return { createToggleHandler: createToggleHandler, isActive: isActive, setItem: setItem, activeItem: activeItem };
}
exports.useMenuState = useMenuState;
